export default "__VITE_ASSET__CmbJtl5w__"